<template>
  <div class="search-box">
    <div class="weui-search-bar" :class="{'weui-search-bar_focusing': !isCancel || currentValue}" @click="toSearch">
      <slot name="left"></slot>
      <form class="weui-search-bar__form" @submit.prevent="onSubmit" action=".">
        <div class="weui-search-bar__box">
          <i class="iconfont icon-sousuo-sousuofangdajing"></i>
          <input
            ref="input"
            maxlength="30"
            type="search"
            class="weui-search-bar__input"
            autocomplete="off"
            v-model="currentValue"
            :readonly="readonly"
            :id="`search_input_${uuid}`"
            :placeholder="placeholder"
            :required="required"
            @focus="onFocus"
            @blur="onBlur"
          >
          <a
            href="javascript:"
            class="clean-text_btn"
            @click.stop="clear"
            v-show="showClearBtn && currentValue"
          >
            <img src="../../image/search/clear.png" alt="cl">
          </a>
        </div>
      </form>
      <a href="javascript:" class="weui-search-bar__cancel-btn" @click.prevent="cancel" v-show="showCancelBtn">{{cancelText}}</a>
      <slot name="right"></slot>
    </div>
    <slot name="tabs"></slot>
    <slot name="match-words"></slot>
    <!-- 搜索历史 -->
    <div class="weui-cells vux-search_show" v-if="isFixed && results.length && showCancelBtn">
      <slot name="result-header"></slot>
      <div class="weui-cell-container" v-collapse="{class: 'history-over-cell', data: ['overHistoryMaxRow', 'isHistoryCollapsed']}">
        <div
          class="weui-cell weui-cell_access"
          :key="index"
          v-for="(item, index) in results"
          @click="handleResultClick(item)"
        >
          <div class="weui-cell__bd weui-cell_primary">
            <p class="weui-cell__item">
              <span>{{item}}</span>
              <!-- <a href="javascript:" class="iconfont icon-tubiaoguifan2" @click.stop="$emit('on-delete', item)"></a> -->
            </p>
          </div>
        </div>
        <div v-show="overHistoryMaxRow" :class="[isHistoryCollapsed ? 'btn-hide' : 'btn-show']" @click="toggleCollapsed('history-over-cell', 'isHistoryCollapsed')">
          <img src='../../image/search/arrow-down.png' class="collapsed-icon" width="12px" height="7px">
        </div>
      </div>
      <slot name="result-footer"></slot>
    </div>
    <!-- 热门标签 -->
    <div class="weui-cells vux-search_show" v-if="isFixed && isShowHotwords && hotWords.length && showCancelBtn">
      <slot name="hot-words-header"></slot>
      <div class="weui-cell-container" v-collapse="{class: 'hot-over-cell', data: ['overHotMaxRow', 'isHotCollapsed']}">
        <div
          class="weui-cell weui-cell_access"
          :key="index"
          v-for="(item, index) in hotWords"
          @click="handleResultClick(item)"
        >
          <div class="weui-cell__bd weui-cell_primary">
            <p class="weui-cell__item">
              <span>{{item}}</span>
              <!-- <a href="javascript:" class="iconfont icon-tubiaoguifan2" @click.stop="$emit('on-delete', item)"></a> -->
            </p>
          </div>
        </div>
        <div v-show="overHotMaxRow" :class="[isHotCollapsed ? 'btn-hide' : 'btn-show']" @click="toggleCollapsed('hot-over-cell', 'isHotCollapsed')">
          <img src='../../image/search/arrow-down.png' class="collapsed-icon" width="12px" height="7px">
        </div>
      </div>
      <slot name="result-footer"></slot>
    </div>
    
  </div>
</template>

<script>
import trackBaidu from '../directives/track_baidu'
import { trackData } from '../directives/track.js'
const maxRow = 3 //搜索历史/热门标签显示的最大行数
const marginLeft = 15 // 搜索历史容器左外边距

export default {
  name: "search",
  props: {
    // 是否自定义跳转路由
    isCustomizeRouteLink: {
      type: Boolean,
      default: false
    },
    // 是否当前页面搜索
    isCurrentSearch: {
      type: Boolean,
      default: false,
    },
    isSearchCinema: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    cancelText: String,
    value: {
      type: String,
      default: ""
    },
    results: {
      type: Array,
      default() {
        return [];
      }
    },
    hotWords: {
      type: Array,
      default() {
        return [];
      }
    },
    autoFixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: "0px"
    },
    position: {
      type: String,
      default: "fixed"
    },
    showClearBtn: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    autoScrollToTop: Boolean,
    iniFucus: Boolean,
    isShowHotwords: { //是否展示热搜词
      type: Boolean,
      default: false
    },
    showCancelBtn: {
      type: Boolean,
      default: true
    }
  },
  created() {
    if (this.value) {
      this.currentValue = this.value;
    }
    this.uuid = Math.random()
      .toString(36)
      .substring(3, 8);
  },
  mounted() {
    const self = this;
    if (this.iniFucus) {
      self.onFocus();
    }
  },
  computed: {
    fixPosition() {
      if (this.isFixed) {
        return this.position === "absolute" ? "absolute" : "fixed";
      }
      return "static";
    }
  },
  methods: {
    onSubmit() {
      this.$emit('on-submit', this.currentValue)
      // trackData({act: 'submit', id: 2003, data: {
      //   bId: this.currentValue
      // }})
      trackBaidu.trackEvent({act: 'submit', data: {id: 3, p: [this.currentValue]}})
    },
    toSearch() {
      if(this.isSearchCinema || this.isCurrentSearch) {
        return
      }
      if(this.isCustomizeRouteLink) {
        return this.$emit('on-router-link')
      }
      return this.$router.push({ path: '/search'})
    },
    clear() {
      this.currentValue = "";
      this.isFocus = true;
      this.setFocus();
      if (this.autoFixed && !this.isFixed) {
        this.isFixed = true;
      }
    },
    cancel() {
      this.isCancel = true;
      this.currentValue = "";
      this.isFixed = false;
      this.$emit("on-cancel");
    },
    handleResultClick(item) {
      this.$emit("result-click", item); // just for compatibility
      this.$emit("on-result-click", item);
      this.isCancel = true;
      this.isFixed = false;
    },
    touch() {
      this.isCancel = false;
      if (this.autoFixed) {
        this.isFixed = true;
      }
      this.$emit("on-touch");
    },
    setFocus() {
      this.$refs.input.focus();
    },
    setBlur() {
      this.$refs.input.blur();
    },
    onFocus() {
      this.isFocus = true;
      this.$emit("on-focus");
      this.touch();
    },
    onBlur() {
      this.isFocus = false;
    },
    // 切换显示隐藏 超出行数的元素
    toggleCollapsed(className, collapsedName) {
      this[collapsedName] = !this[collapsedName]
      const elms = document.querySelectorAll(`.${className}`)
      for(let i of elms) {
        i.style.display = this[collapsedName] ? "none" : "inline-block"
      }
      // this.isHistoryCollapsed = !this.isHistoryCollapsed
      // const elms = document.querySelectorAll('.over-cell')
      // for(let i of elms) {
      //   i.style.display = this.isHistoryCollapsed ? "none" : "inline-block"
      // }
    }
  },
  directives: {
    collapse: {
      inserted: function(el, binding, vnode, oldnode) {
        const childEls = el.querySelectorAll('.weui-cell')
        let leftFirstItems = []
        for(let i of childEls) {
          let { left } = i.getBoundingClientRect()
          // 存储每一行第一个元素
          if(left == marginLeft) {
            leftFirstItems.push(i)
          }
          // 校验是否已超出最大行数
          if(leftFirstItems.length > maxRow) {
            i.style.display = "none"
            i.classList.add(binding.value.class) // 标记需隐藏的DOM节点
          }
        }
        // 标记全部数据超出最大行数
        if(leftFirstItems.length > maxRow) {
          vnode.context[binding.value.data[0]] = true
          vnode.context[binding.value.data[1]] = true
        }
      }
    }
  },
  data() {
    return {
      currentValue: "",
      isCancel: true,
      isFocus: false,
      isFixed: false,
      overHistoryMaxRow: false, //历史列表宽度是否超出限定3行宽度
      isHistoryCollapsed: false, //历史是否折叠
      overHotMaxRow: false, //热门列表宽度是否超出限定3行宽度
      isHotCollapsed: false, //热门是否折叠
    };
  },
  watch: {
    isFixed(val) {
      if (val === true) {
        this.setFocus();
        this.isFocus = true;

        if (this.autoScrollToTop) {
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 150);
        }
      } else {
      }
    },
    value(val) {
      this.currentValue = val;
    },
    currentValue(val) {
      this.$emit("input", val);
      this.$emit("on-change", val);
    }
  }
};
</script>

<style lang="less" scoped>
@weuiCellBg: #ffffff;
@weuiCellBorderColor: #ededed;
@weuiCellGapV: 5px;
@weuiCellGapH: 15px;
@weuiCellInnerGapH: 0.35em;
@weuiCellHeight: 20px;
@cell-font-size: 13px;
@weuiCellFontSize: @cell-font-size;
@weuiCellLabelWidth: 105px;
@weuiCellLineHeight: unit(
  (@weuiCellHeight - 2 * @weuiCellGapV) / @weuiCellFontSize
); // 高度为44px，减去上下padding的行高
@weuiCellsMarginTop: unit(20 / @weuiCellFontSize, em);
@search-cancel-font-color: #000000;
@search-bg-color: rgba(255, 255, 255, 1);
@search-placeholder-font-color: #9b9b9b;

.setTopLine(@c: #EDEDED) {
  content: " ";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 1px;
  border-top: 1px solid @c;
  color: @c;
  transform-origin: 0 0;
  transform: scaleY(0.5);
}

.setBottomLine(@c: #EDEDED) {
  content: " ";
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  height: 1px;
  border-bottom: 1px solid @c;
  color: @c;
  transform-origin: 0 100%;
  transform: scaleY(0.5);
}

.setLeftLine(@c: #EDEDED) {
  content: " ";
  position: absolute;
  left: 0;
  top: 0;
  width: 1px;
  bottom: 0;
  border-left: 1px solid @c;
  color: @c;
  transform-origin: 0 0;
  transform: scaleX(0.5);
}

.setRightLine(@c: #EDEDED) {
  content: " ";
  position: absolute;
  right: 0;
  top: 0;
  width: 1px;
  bottom: 0;
  border-right: 1px solid @c;
  color: @c;
  transform-origin: 100% 0;
  transform: scaleX(0.5);
}

.search-box {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 21;
  backdrop-filter: blur(5px);
}
.tabs {
  display: inline-flex;
  width: 100%;
  border-top: 1px solid rgb(237, 237, 237);
  border-bottom: 1px solid rgb(237, 237, 237);
  background-color: #fff;
  .tab {
    width: 50%;
    text-align: center;
    font-size: 14px;
    height: 44px;
    line-height: 44px;
    color: rgb(121, 125, 130);
  }
  .choose {
    color: rgb(192, 49, 49);
  }
}
.weui-cells.vux-search_show {
  margin-top: 0 !important;
  overflow-y: auto;
  max-height: calc(~"100vh - 50px");

  &::-webkit-scrollbar {
    display: none;
  }
}

.weui-cells {
  padding-bottom: 13px;
  //   margin-top: @weuiCellsMarginTop;
  background-color: @weuiCellBg;
  line-height: @weuiCellLineHeight;
  font-size: @weuiCellFontSize; //cell中间有效高度23px，跟客户端默认图标尺寸一致

  overflow: hidden; //因为每个cell的border使用before元素left搞的，ie下伪元素的containing block估计跟标准不同，在cell上用oh不生效

  // onepx
  position: relative;
  &:not(:last-of-type):after {
    .setBottomLine();
    left: 15px;
  }
}
.weui-cell-container {
  margin: 0 10px;

  
  position: relative;
}
.btn-hide {
  display: inline-block;
  height: 30px;
  font-size: 13px;
  line-height: 30px;
  margin: 5px 0 5px 15px;
  align-items: center;
}
.btn-show {
  display: inline-block;
  transform: rotate(180deg);
  height: 30px;
  font-size: 13px;
  line-height: 30px;
  margin: 5px;
  align-items: center;
}

.weui-cell {
  padding: 9px 0 9px @weuiCellGapH;
  position: relative; //这个是为了兼容cells容器onepx方案被before挡住而做的
  display: flex;
  align-items: center;
  //   &:before {
  //     .setTopLine(@weuiCellBorderColor);
  //     left: @weuiCellGapH;
  //   }
  .weui-cell__bd {
    width: 100%;
    .weui-cell__item {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 30px;
      margin: 0;
      position: relative;
      span {
        color: rgb(25, 26, 27);
        font-size: 13px;
      }
      a {
        width: 50px;
        height: 48px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        z-index: 100;
        color: #797d82;
      }
    }
  }
}

.weui-search-bar {
  position: relative;
  display: flex;
  box-sizing: border-box;
  background-color: @search-bg-color;
  &:before {
    .setTopLine(#ededed);
  }
  // &:after {
  //   .setBottomLine(#EDEDED);
  // }
  &.weui-search-bar_focusing {
    .weui-search-bar__cancel-btn {
      display: block;
    }
    .weui-search-bar__label {
      display: none;
    }
  }
}
.weui-search-bar__form {
  transition: width 2s;
  position: relative;
  flex: auto;
  margin: 7px 0;
  &:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 200%;
    height: 200%;
    transform: scale(0.5);
    transform-origin: 0 0;
    border-radius: 10px;
    border: 1px solid #e6e6ea;
    box-sizing: border-box;
    background: #ffffff;
  }
}
.weui-search-bar__box {
  position: relative;
  padding-left: 34px;
  padding-right: 30px;
  height: 30px;
  width: 100%;
  box-sizing: border-box;
  z-index: 1;
  border-radius: 3px;
  background: rgb(244, 244, 244);
  .weui-search-bar__input {
    padding: 4px 0;
    width: 100%;
    height: 20/14em;
    border: 0;
    font-size: 14px;
    line-height: 20/14em;
    box-sizing: content-box;
    background: transparent;
    color: rgb(25, 26, 27);
    &:focus {
      outline: none;
    }
  }
}

.icon-tubiaoguifan2 {
  padding: 0 15px;
  line-height: 30px;
  font-size: 13px;
  &::before {
    transform: scale(0.8);
  }
}

.clean-text_btn {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 10px;
  line-height: 30px;
  display: flex;
  align-items: center;
  height: 30px;
  img {
    width: 13px;
    color: #797d82;
  }
}

.icon-sousuo-sousuofangdajing {
  position: absolute;
  left: 7px;
  top: 0;
  line-height: 30px;
  font-size: 21px;
  color: rgb(121, 125, 130);
}
.weui-search-bar__cancel-btn {
  display: none;
  margin-left: 15px;
  line-height: 30px;
  color: rgb(25, 26, 27);
  font-size: 14px;
  white-space: nowrap;
  cursor: pointer;
}
.weui-search-bar__input:not(:valid) ~ .weui-icon-clear {
  display: none;
}

//干掉input[search]默认的clear button
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}

.weui-cell_access {
  display: inline-block;
  background: #f4f4f4;
  height: 30px;
  padding: 0px 12px;
  font-size: 13px;
  line-height: 13px;
  margin: 5px;
  //   -webkit-tap-highlight-color: rgba(0,0,0,0);
  //   color: inherit;
  //   &:active {
  //       background-color: #ECECEC;
  //   }
  //   .weui-cell__ft {
  //       padding-right: 13px;
  //       position: relative;
  //       &:after {
  //           content: " ";
  //           position: absolute;
  //           top: 50%;
  //           margin-top: -4px;
  //           right: 2px;
  //       }
  //   }
}
</style>
